import React, { useState } from "react";
import { Dropdown } from "react-bootstrap";
import { MdSettings } from "react-icons/md";
import { BsDot } from "react-icons/bs";
import { MdNotifications, MdNotificationsActive } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { markNotificationAsRead } from "../../../store/reducers/notification";

const NotificationDropdown = () => {
  const [showDropdown, setShowDropdown] = useState(false);
  const [viewAll, setViewAll] = useState(false);
  const [hoveredId, setHoveredId] = useState(null);
  const dispatch = useDispatch();
  const userId = localStorage.getItem("user_id")
  const organizationId = localStorage.getItem("organisation_id");

  const {
    data: notifications = [],
    loading = false,
    error = null,
  } = useSelector((state) => state.notifications || {});

  const toggleDropdown = (isOpen) => {
    setShowDropdown(isOpen);
    if (!isOpen) setViewAll(false);
  };

  // Count unread notifications
  const unreadCount = notifications.filter((n) => !n.is_read).length;

  const displayedNotifications = viewAll
    ? notifications.slice(0, 5)
    : notifications.slice(0, 3);

  return (
    <div className="position-relative d-inline-block">
      <Dropdown show={showDropdown} onToggle={toggleDropdown}>
        <Dropdown.Toggle
          variant="link"
          className="text-dark border-0 p-0 position-relative"
          id="notification-dropdown"
        >
          <MdNotifications size={28} />

          {unreadCount > 0 && (
            <span
              className="position-absolute top-0 start-90 translate-middle badge rounded-pill bg-danger"
              style={{
                fontSize: "0.65rem",
                padding: "4px 6px",
                borderRadius: "50%",
                lineHeight: 1,
              }}
            >
              {unreadCount > 3 ? "3+" : unreadCount}
            </span>
          )}
        </Dropdown.Toggle>

        <Dropdown.Menu
          className="p-0 shadow"
          style={{
            minWidth: "320px",
            borderRadius: "12px",
            maxHeight: viewAll ? "400px" : "auto",
            overflowY: viewAll ? "auto" : "visible",
          }}
        >
          <div className="d-flex justify-content-between align-items-center px-3 py-2 border-bottom">
            <strong>Notifications</strong>
            <MdSettings size={20} />
          </div>

          {loading ? (
            <div className="px-3 py-3 text-center">Loading...</div>
          ) : error ? (
            <div className="px-3 py-3 text-danger text-center">{error}</div>
          ) : notifications.length === 0 ? (
            <div className="px-3 py-3 text-muted text-center">No notifications</div>
          ) : (
            displayedNotifications.map((item, index) => (
              <div
                key={index}
                className="px-3 py-2 border-bottom d-flex align-items-center"
                style={{
                  backgroundColor:
                    hoveredId === index ? "#ffdbdf" : "transparent",
                  cursor: "pointer",
                  overflow: "hidden",
                  borderRadius: hoveredId === index ? "8px" : "0px",
                  transition: "background-color 0.2s, border-radius 0.2s",
                }}
                onMouseEnter={() => {
                  setHoveredId(index);
                  if (!item.is_read) {
                    dispatch(markNotificationAsRead({
                      user_id: +userId,
                      organisation_id: +organizationId,
                      title: item.title
                    }));
                  }
                }}
                onMouseLeave={() => setHoveredId(null)}
              >
                <div
                  className="me-2 mt-1 border rounded-circle p-1 d-flex align-items-center justify-content-center"
                  style={{ background: "#F6605F" }}
                >
                  <MdNotificationsActive color={"white"} size={24} />
                </div>
                <div className="flex-grow-1">
                  <div className="d-flex align-items-center">
                    <BsDot
                      size={30}
                      color={item.is_read ? "gray" : "red"}
                    />
                    <strong>{item.title}</strong>
                  </div>
                  <div className="ms-4" style={{ fontSize: "0.875rem" }}>
                    {item.description}
                  </div>
                </div>
              </div>
            ))
          )}

          {notifications.length > 3 && !viewAll && (
            <div className="text-center py-2">
              <button
                className="btn btn-link text-primary fw-bold p-0"
                onClick={() => setViewAll(true)}
              >
                View all Notifications
              </button>
            </div>
          )}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};

export default NotificationDropdown;
